import React, { createContext, useContext, useEffect, useState } from 'react';
import { IDatabase, DatabaseFactory } from '@study-tracker/data';

interface DatabaseContextValue {
  db: IDatabase | null;
  isReady: boolean;
  error: Error | null;
}

const DatabaseContext = createContext<DatabaseContextValue>({
  db: null,
  isReady: false,
  error: null,
});

export const DatabaseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [db, setDb] = useState<IDatabase | null>(null);
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    const initialize = async () => {
      try {
      const database = DatabaseFactory.getDatabase();
      await database.subjects.findAll();
      if (!active) return;
      setDb(database);
      setIsReady(true);
      } catch (err: unknown) {
        console.error('Failed to initialize database:', err);
        if (active) setError(err instanceof Error ? err : new Error(String(err)));
      }
    };
    void initialize();
    return () => { active = false; };
  }, []);

  return (
    <DatabaseContext.Provider value={{ db, isReady, error }}>
      {children}
    </DatabaseContext.Provider>
  );
};

export function useDatabase(): DatabaseContextValue {
  return useContext(DatabaseContext);
}
